import React from "react"
import { EstatePlanContainer } from "../janowotwo/janowoTwoStyle"
import { Col, Container, Row } from "react-bootstrap"
//import planImage from "@/images/puck/molo_w_pucku_4.svg"
import planImage from "@/images/z-22/2024.10.04_Plan_Osiedla_Pogodne-ograniczenie_do_jednego_etapu.jpg"

const PuckEstatePlan = () => (
  <EstatePlanContainer className="plan">
    <Container>
      <Row>
        <Col className="plan-title" xs="12">
          <h2>Plan Osiedla</h2>
        </Col>
      </Row>
    </Container>
    <Container>
      <Row>
        <Col className="no-padding" xs="12">
          <div className="plan-container" style={{ paddingBottom: "40px" }}>
            <img src={planImage} alt={`Plan`} />
          </div>
        </Col>
      </Row>
    </Container>
  </EstatePlanContainer>
)

export default PuckEstatePlan
